import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AudioFileIcon = (props: IconProps) => (
  <Icon width="87px" height="77px" viewBox="0 0 87 77" {...props}>
    <path
      fillRule="evenodd"
      d="M40.345 10h7.31v57.778h-7.31V10Zm21.928 9.63h7.309v38.518h-7.31V19.63ZM36.69 22.84h-7.31v32.098h7.31V22.84Zm-18.273 9.63h7.31v16.049h-7.31v-16.05ZM7.454 35.678h7.31v9.63h-7.31v-9.63Zm73.092 0h-7.31v9.63h7.31v-9.63Zm-21.928-9.63H51.31v25.68h7.31v-25.68Z"
      clipRule="evenodd"
    />
  </Icon>
);

export default memo(AudioFileIcon);
